import { render } from "./응급의학과.vue?vue&type=template&id=e83d6c68"
import script from "./응급의학과.vue?vue&type=script&lang=js"
export * from "./응급의학과.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__